import React from "react";
import styles from "./RichTextView.module.css";

type Props = {
  html?: string | null;
};

export const RichTextView: React.FC<Props> = ({ html }) => {
  if (!html) return null;

  return (
    <div
      className={styles.richText}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};
